import React, { useState, useEffect } from 'react';
import { Button } from 'antd';

//create your forceUpdate hook
function useForceUpdate() {
    const [value, setValue] = useState(0); // integer state


    return () => setValue(value => value + 1); // update the state to force render
}

const SvgRender = (props) => {
    // call your hook here
    // const forceUpdate = useForceUpdate();
    const [renderState, setRenderState] = useState(0); 


    useEffect(() => {
        // if (props.svg != undefined) {
        //     const [x,y,w,h] =props.svg.attributes.viewBox.split(" ");
        //     console.log("w, h ", w,h);
        //     if (w>h) {
        //         svgAttributes = {
        //             width: String(props.zoomValue) + '%'
        //         }
        //     }
        //     else {
        //         svgAttributes = {
        //             height: String(props.zoomValue) + 'vh'
        //         }
        //     }
        // }

    });

    const changeColor = (i) => {
        var tempSvg = props.svg;
        console.log(props.svg.children[i].attributes['fill']);
        tempSvg.children[i].attributes['fill'] = props.color;
        props.setSvg(tempSvg);
        // it is not rerendering when I update the state so I have to force it.
        setRenderState(renderState + 1);
    }

    const deletePath = (i) => {
        var tempSvg = props.svg;
        tempSvg.children.splice(i, 1);//[i]
        props.setSvg(tempSvg);
        // it is not rerendering when I update the state so I have to force it.
        setRenderState(renderState + 1);
    }



    // const mergeColors = () => {
    //     var tempSvg = props.svg;
    //     var newChildren = [];
    //     var usedColors = [];

    //     for (let index = 0; index < props.svg.children.length; index++) {
    //         if (!usedColors.includes(props.svg.children[index].attributes['fill'])) {
    //             usedColors.push(props.svg.children[index].attributes['fill']);
    //         }
    //     }

    //     for (let colorIndex = 0; colorIndex < usedColors.length; colorIndex++) {
    //         var currentColor = usedColors[colorIndex];



    //         var childPath = '';
    //         for (let index = 0; index < props.svg.children.length; index++) {
                
    //             if (props.svg.children[index].attributes['fill'] == currentColor) {
    //                 childPath += props.svg.children[index].attributes['d'] + " "
    //             }
    //         }
    //         const child = Object.assign({}, props.svg.children[0]);
    //         const attributes = Object.assign({}, child.attributes);
    //         attributes.d = childPath;
    //         attributes.fill = currentColor;
    //         child.attributes = attributes;
    //         newChildren.push(child);
    //     }

    //     console.log(newChildren);
    //     tempSvg.children = newChildren;
    //     props.setSvg(tempSvg);
    //     forceUpdate();
    // }

    // const splitPaths = () => {
    //     var tempSvg = props.svg;
    //     var newChildren = [];
    //     for (let index = 0; index < props.svg.children.length; index++) {

    //         // if (props.svg.children[index].attributes['fill'] === "white") {
    //         const newString = props.svg.children[index].attributes['d'].replace(/M/g, "|M")

    //         const newArray = newString.split("|");


    //         for (var i = 0; i < newArray.length; i++) {
    //             var item = (' ' + newArray[i]).slice(1);
    //             if (item !== "") {
    //                 //console.log(item, i);
    //                 const child = Object.assign({}, props.svg.children[index]);
    //                 console.log("item", item);
    //                 const attributes = Object.assign({}, child.attributes);
    //                 attributes.d = item;
    //                 child.attributes = attributes;
    //                 console.log("attributes after", child.attributes.d);
    //                 console.log("child after", child);

    //                 newChildren.push(child);
    //             }
    //         }
    //     }
    //     console.log("newChildren: ", newChildren);
    //     tempSvg.children = newChildren;
    //     props.setSvg(tempSvg);
    //     forceUpdate();
    // }

    const clickHandler = (i) => {
        if (props.isCanvasDisabled) {
            return;
        }
        if (props.mouseMode === "fill") {
            changeColor(i);
        } else if (props.mouseMode === "delete") {
            deletePath(i);
        }

    }
    const mouseOverHandler = (e, i) => {
        if (props.isCanvasDisabled) {
            return;
        }
        if (e.buttons == 1 || e.buttons == 3) {
            if (props.mouseMode === "fill") {
                changeColor(i);
            } else if (props.mouseMode === "delete") {
                deletePath(i);
            }
        }
    }

    const svgAttributes = {
        height: String(props.zoomValue) + 'vh'
    };


    if (props.svg != undefined && props.svg.attributes != undefined) {
        return (
            <div key={props.svg}>
                <svg viewBox={props.svg.attributes.viewBox} {...svgAttributes} xmlns="http://www.w3.org/2000/svg">
                    {props.svg.children.map((object, i) => <path onMouseOver={(e) => mouseOverHandler(e, i)} onClick={() => clickHandler(i)} d={object.attributes["d"]} strokeWidth="1" stroke="grey" fill={object.attributes["fill"]} fillRule={object.attributes['fill-rule']} />)}
                </svg>
            </div>
        );

    } else {
        return (
            <div key={props.svg}></div>
        );
    }

};

export default SvgRender;